// import React from "react";
// import { Box, Typography } from "@mui/material";

// export default function PdfViewer({ file }) {
//   if (!file && false) {
//     return (
//       <Box sx={{ p: 4 }}>
//         <Typography variant="h6" color="text.secondary">
//           Select a file to preview
//         </Typography>
//       </Box>
//     );
//   }

//   return (
//     <iframe
//       title="PDF Viewer"
//     //   src={file}
//     src={'/test.pdf'}
//       style={{
//         width: "100%",
//         height: "100%",
//         border: "none"
//       }}
//     />
//   );
// }
import React, { useEffect, useState } from "react";
import { Box, Typography } from "@mui/material";

export default function PdfViewer({ pdfBase64 }) {
  const [pdfUrl, setPdfUrl] = useState(null);

  useEffect(() => {
    if (!pdfBase64) return;

    try {
      // Decode base64 → binary
      const byteCharacters = atob(pdfBase64);
      const byteNumbers = new Array(byteCharacters.length);

      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }

      const byteArray = new Uint8Array(byteNumbers);
      const blob = new Blob([byteArray], { type: "application/pdf" });

      const url = URL.createObjectURL(blob);
      setPdfUrl(url);

      // Cleanup
      return () => URL.revokeObjectURL(url);
    } catch (err) {
      console.error("Failed to load PDF:", err);
    }
  }, [pdfBase64]);

  if (!pdfBase64) {
    return (
      <Box sx={{ p: 4 }}>
        <Typography variant="h6" color="text.secondary">
          Select a PDF to preview
        </Typography>
      </Box>
    );
  }

  return (
    <iframe
      title="PDF Viewer"
      src={pdfUrl}
      style={{
        width: "100%",
        height: "100%",
        border: "none",
      }}
    />
  );
}
